import { useIsMobile } from '@sravni/react-utils';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useChannel } from 'entities/siteSettings/lib';

import { sendContactThunk } from 'features/SendLoansContactData/lib/sendContactThunk';

export const useSendLoansContactData = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const channel = useChannel();

  return useCallback(async () => {
    dispatch(
      sendContactThunk({ sourceUrl: window.location.href, deviceType: isMobile ? 'mobile' : 'desktop', channel }),
    );
  }, [dispatch, isMobile, channel]);
};
